import { TranslationRepository } from '../data/translation-repository';

export class DeleteTranslationUseCase {
  constructor(private readonly repository: TranslationRepository) {}

  async execute(id: number): Promise<void> {
    return this.repository.delete(id);
  }
}
